export default __webpack_public_path__ + "static/media/SPOgirl.6b07d741.png";